export * from './device-attributes.component';
